import { render, staticRenderFns } from "./IcoPersonFrame.vue?vue&type=template&id=e090feb6"
import script from "./IcoPersonFrame.vue?vue&type=script&lang=js"
export * from "./IcoPersonFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports